/**
 * What the booking error popup (BookingErrorModal) says when Book can't continue —
 * the GT Exclusive (Nuitee) and Booking.com/Expedia (Stay22) rows share these.
 */
export interface BookingErrorCopy {
  title: string;
  message: string;
}

export const MISSING_DATES_ERROR: BookingErrorCopy = {
  title: 'Choose your dates',
  message: 'Pick check-in and check-out dates, then tap Book.',
};

export const MISSING_PLACE_ERROR: BookingErrorCopy = {
  title: "We can't book this place",
  message: "It's missing the details we need to find it on the booking site.",
};

export const SERVICE_UNAVAILABLE_ERROR: BookingErrorCopy = {
  title: 'Booking is temporarily unavailable',
  message: 'Please try again in a few minutes.',
};

/** Copy for a failed Nuitee hotel lookup / SSO call, by API error code or HTTP status. */
export function bookingErrorCopy(errorCode?: string, errorStatus?: number): BookingErrorCopy {
  if (errorCode === 'HOTEL_NOT_IN_INVENTORY') {
    return {
      title: "Exclusive rates aren't available for this hotel",
      message: "This hotel isn't in our booking partner's inventory right now, so we can't open it.",
    };
  }
  if (
    errorCode === 'USER_NOT_FOUND' ||
    errorCode === 'MISSING_USER_EMAIL' ||
    errorStatus === 401 ||
    errorStatus === 403
  ) {
    return { title: 'Log in to book', message: 'Log in to your Globe Thrivers account, then try again.' };
  }
  if (errorCode === 'SSO_NOT_CONFIGURED' || errorStatus === 503 || errorStatus === 504) {
    return SERVICE_UNAVAILABLE_ERROR;
  }
  return { title: "We couldn't open the booking page", message: 'Please try again.' };
}
